export const admin_auth_loading_status = "admin_auth_loading_status";

export const admin_auth_error_status = "admin_auth_error_status";

export const admin_auth_login_success_status = "admin_auth_login_success_status";

export const admin_auth_logout_success_status = "admin_auth_logout_success_status";
